import React from 'react';

export const InfraMail = ({ width = 30, height = 30 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="3" width="24" height="24" rx="2" fill="#0D0D0D" />
    <path d="M15 9L21.0622 19.5H8.93782L15 9Z" fill="white" />
  </svg>
);
